import type { ReadOnlyExperiments } from '@wix/fe-essentials/dist/types/exports/experiments';

export const getIsAppTemplatesRedisgn = (experiments: ReadOnlyExperiments) => {
  return experiments?.enabled('specs.dcc.startFromScratchRedesign');
};

export const isDevibeExperimentEnabled = (experiments: ReadOnlyExperiments) => {
  return experiments?.enabled('specs.dcc.devCenterDevVibe');
};
